import { useEffect } from "react";
import styles from "../dashboard/MainContent.module.css";
import { HeaderBotList } from "./HeaderBotList";
import { ChartAndListBotActive } from "./ChartAndListBotActive";
import AdsComponents from "../ads/AdsComponents";
import TableHeader from "./TableHeader";
import { useBotDemo } from "../../context/botDemoContext";
import ListBotActive from "./ListBotActive";
import { IconDiamond } from "../../assets/icons";
import CurrentValueForwardTesting from "./CurrentValueForwardTesting";

export const MainContentForwardTestingBot = () => {
  const { fetchBotListsDemo, fetchStrategyLists } = useBotDemo();

  useEffect(() => {
    fetchBotListsDemo();
    fetchStrategyLists();
  }, []);

  return (
    <div className="">
      <div className="bg-[rgba(0,122,255,0.15)] gap-2 p-3 rounded-xl border-[1.5px] border-[#007AFF] flex items-center mb-5">
        <IconDiamond className="w-full max-w-[24px] h-[24px] text-[#007AFF]" />
        <span className="text-sm md:text-base">
          <strong>Try our bots risk-free —</strong> Connect your Binance API, no
          funds required
        </span>
      </div>
      <div className="flex md:hidden">
        <ListBotActive />
      </div>
      <div className="flex gap-4 bg-black-500 mb-5">
        <ChartAndListBotActive />
        <div className="w-[500px] rounded-xl flex-col hidden md:flex">
          <CurrentValueForwardTesting />
          <ListBotActive />
        </div>
      </div>
      <TableHeader />
      <div className="mt-5">
        <AdsComponents className={"!h-[300px]"} />
      </div>
    </div>
  );
};
